import React, { useContext } from 'react';
import {
  ComponentFactory,
  ComponentParams,
  ComponentRendering,
  Field,
  RichText,
  SitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import { useLocation } from 'react-router-dom';
import './index.scss';
import { APIWebstoreContext } from '../../context/globalContext';

export type PaymentPendingProps = {
  fields: {
    PendingText: Field<string>;
    Title: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

interface Props {
  children: React.ReactElement;
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
}

const PaymentPending = (props: PaymentPendingProps & Props): React.JSX.Element => {
  const { fields } = props;
  const { state } = useContext(APIWebstoreContext);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const invoiceNumber = searchParams.get('invoiceNumber') || '';
  const paymentType = searchParams.get('paymentType') || '';

  function replaceText(): Field<string> {
    let paymentPendingText = fields.PendingText.value;
    paymentPendingText = paymentPendingText.replace('##PAYMENT_TYPE##', paymentType);
    paymentPendingText = paymentPendingText.replace('##EMAIL_ID##', state?.userEmail || '');
    paymentPendingText = paymentPendingText.replace('##INVOICE_NUMBER##', invoiceNumber);
    fields.PendingText.value = paymentPendingText;
    return fields.PendingText;
  }

  return (
    <div className="paymentCenterContainer">
      <div className="paymentPendingSection">
        <div className="paymentPendingHeader">
          <h1>{fields?.Title?.value}</h1>
        </div>
        <div className="paymentPendingContent">
          <RichText className="paymentPendingRichText" field={replaceText()} />
        </div>
      </div>
    </div>
  );
};

export default PaymentPending;
